import { render, staticRenderFns } from "./approvalstatus.vue?vue&type=template&id=7e5f1b71&scoped=true"
import script from "./approvalstatus.vue?vue&type=script&lang=js"
export * from "./approvalstatus.vue?vue&type=script&lang=js"
import style0 from "./approvalstatus.vue?vue&type=style&index=0&id=7e5f1b71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f1b71",
  null
  
)

export default component.exports